import { UserRepository } from "@/api/Repositories";
import Util from "@/util";

const state = {
  all: []
};

const getters = {};

const actions = {
  getAllUsers({ commit }, obj) {
    return new Promise((resolve, reject) => {
      UserRepository.getAll(obj)
        .then(response => {
          commit(
            "setUsers",
            response.data.data.map(apiUser =>
              Util.convertUserFromApiModelToFrontModel(apiUser)
            )
          );
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addUser({ dispatch }, user) {
    return new Promise((resolve, reject) => {
      let apiModel = Util.convertUserFromFrontModelToApiModel(user);
      delete apiModel.id;
      UserRepository.create(apiModel)
        .then(() => {
          dispatch("getAllUsers")
            .then(() => {
              resolve();
            })
            .catch(errorGet => {
              reject(errorGet);
            });
        })
        .catch(errorCreate => {
          reject(errorCreate);
        });
    });
  },
  editUser({ dispatch }, user) {
    return new Promise((resolve, reject) => {
      let apiModel = Util.convertUserFromFrontModelToApiModel(user);
      UserRepository.update(apiModel)
        .then(() => {
          dispatch("getAllUsers")
            .then(() => {
              resolve();
            })
            .catch(errorGet => {
              reject(errorGet);
            });
        })
        .catch(errorUpdate => {
          reject(errorUpdate);
        });
    });
  },
  deleteUser({ dispatch }, userId) {
    return new Promise((resolve, reject) => {
      UserRepository.delete(userId)
        .then(() => {
          dispatch("getAllUsers")
            .then(() => {
              resolve();
            })
            .catch(errorGet => {
              reject(errorGet);
            });
        })
        .catch(errorDelete => {
          reject(errorDelete);
        });
    });
  }
};

const mutations = {
  setUsers(state, users) {
    state.all = users;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
